module.exports = __webpack_public_path__ + "static/media/Rectangle.32162f64.png";